import { render, staticRenderFns } from "./TemplateMessageForm.vue?vue&type=template&id=78c46ee8&scoped=true"
import script from "./TemplateMessageForm.vue?vue&type=script&lang=js"
export * from "./TemplateMessageForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageForm.vue?vue&type=style&index=0&id=78c46ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c46ee8",
  null
  
)

export default component.exports